import React from 'react';
import AdminAlertsPanel from '../components/AdminAlertsPanel';

export default function AdminAlerts() {
  return <AdminAlertsPanel category="all" title="All Alerts" subtitle="All borrower and partner activity" />;
}
